import 'BomdisoftComponents/console/styles.css';
import { Skeleton } from 'BomdisoftComponents/skeletons/skeleton';

const BAR_WIDTHS = ['64%', '48%', '72%', '56%'];

export type PlaceholderRowsProps = { label: string; testId: string; twistyColumn: boolean };

export const PlaceholderRows = ({ label, testId, twistyColumn }: PlaceholderRowsProps) => (
  <div aria-label={label} className='bomdisoft-console-nav-placeholders' data-testid={testId} role='status'>
    {BAR_WIDTHS.map(width => (
      <span className='bomdisoft-console-nav-row' key={width}>
        {twistyColumn ? <span className='bomdisoft-console-nav-twisty' data-leaf='' /> : null}
        <span className='bomdisoft-console-nav-placeholder-item'>
          <Skeleton height={18} variant='rounded' width={18} />
          <Skeleton variant='text' width={width} />
        </span>
      </span>
    ))}
  </div>
);
